import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { LoginButton } from "./LoginButton";
import { GlobalMenu } from "./GlobalMenu";
import { InteractionStatus } from "@azure/msal-browser";

export const LoginLogoutButton = () => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <GlobalMenu />;
  } else if (
    inProgress !== InteractionStatus.Startup &&
    inProgress !== InteractionStatus.HandleRedirect
  ) {
    // inProgress check prevents sign-in button from being displayed briefly after returning from a redirect sign-in. Processing the server response takes a render cycle or two
    return <LoginButton />;
  } else {
    return null;
  }
};
